import { createFileRoute } from "@tanstack/react-router";
import { KitchenPage } from "../features/kots/kitchen-page";

export const Route = createFileRoute("/orders/kots")({ component: KitchenPage });
